exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabLinksDossier a:hover{background-image:none;padding-left:0}.flex-container{border:1px solid #c7c7c7}", ""]);

// exports
